export default __webpack_public_path__ + "static/media/error.c4520f23.svg";